import { render, staticRenderFns } from "./MatchesView.vue?vue&type=template&id=50e03077"
import script from "./MatchesView.vue?vue&type=script&lang=js"
export * from "./MatchesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports